var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Snackbar, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
function CouponSnackbar(_a) {
    var isOpen = _a.isOpen, onReopen = _a.onReopen, onClose = _a.onClose, message = _a.message, _b = _a.isClickable, isClickable = _b === void 0 ? false : _b;
    var messageNode = (_jsx("span", __assign({ onClick: onReopen, className: "font-medium flex items-center h-full" }, { children: message })));
    return (_jsx(Snackbar, { open: isOpen, anchorOrigin: { vertical: "top", horizontal: "right" }, sx: {
            marginTop: "80px",
            "& .MuiSnackbarContent-root": {
                backgroundColor: "#2C2C2C",
                color: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.4)",
                flexWrap: "nowrap",
                maxWidth: "420px",
                fontFamily: "Nunito Sans",
                fontSize: "14px",
                fontStyle: "normal",
                cursor: isClickable ? "pointer" : "default",
            },
        }, message: messageNode, action: _jsx(IconButton, __assign({ size: "small", "aria-label": "close", color: "inherit", onClick: onClose, sx: { color: "#94a3b8", "&:hover": { color: "#ffffff" } } }, { children: _jsx(CloseIcon, { fontSize: "small" }) })) }));
}
export default CouponSnackbar;
